export default __webpack_public_path__ + "static/media/wwdatabase.ac04dd45.png";